import React, { Component } from 'react';
import propTypes from 'prop-types';

import Modal from 'js/components/global/Modal';

class CountdownModal extends Component {
  twoDigitNumber = (int) => {
    return (int <= 9) ? `0${ int }` : int;
  }

  render() {
    const { minutes, seconds, disable, title, copy, btnCopy, onRequestClose } = this.props;

    return (
      <Modal
        { ... this.props }
      >
        <div className="countdown-modal-wrap">
          <p className="hero">{ title }</p>
          <hr className="gray"/>
          <p>{ copy }</p>
          { !disable &&
            <span>{ this.twoDigitNumber(minutes) }:{ this.twoDigitNumber(seconds) }</span>
          }
          <div className="row">
            <button className="sm-10 sm-offset-1 md-6 md-offset-3 btn-primary stillhere" onClick={ onRequestClose }>{ btnCopy }</button>
          </div>
        </div>
      </Modal>
    );
  }
}

CountdownModal.propTypes = {
  minutes: propTypes.number,
  seconds: propTypes.number,
  disable: propTypes.bool,
  title: propTypes.string,
  copy: propTypes.string,
  btnCopy: propTypes.string,
  onRequestClose: propTypes.func
};

export default CountdownModal;



// WEBPACK FOOTER //
// ./js/components/global/countdown/CountdownModal.js